<template>    
  <el-dialog 
    width="500px"
    title="安全锁屏" 
    :visible.sync="dialogLockScreen.isShow"
    :append-to-body="true"
    :close-on-click-modal="false"
    :show-close="false"
    @open='open' >
    <el-form ref="form" :model="form" label-width="100px" @submit.native.prevent>
      <el-form-item label="请输入密码">       
        <el-col :span="20">
            <el-input 
                v-model="form.pwd" 
                show-password
                 @keyup.enter.native="Save">
                </el-input>          
        </el-col>         
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button type="primary" @click="Save">确 定</el-button>
    </div>
  </el-dialog>
</template>

<script  type='text/ecmascript-6'>
export default {
  props:{
    dialogLockScreen:{}
  },
  data (){
    return {
      form : {
        pwd:''
      },     
    }
  },  
  components:{
  },
  computed:{
  },
  mounted(){
  },
  methods:{   
    open:function(){      
      this.form.pwd = ''
    },
    Save(){
      var that = this
      this.axios({
        method:'post',
        url:that.global.serverSrc + '/api/User/CheckPwd',         
        data:this.form
      }).then(function (resp) {
        if(resp.data.errorCode==0){
          that.dialogLockScreen.isShow = false
        }else {
          that.$message.warning(resp.data.message);
        }  
      }).catch(resp => {         
        console.log('请求失败：' + resp.message + ',' + resp.stack)
      })
    },   
    handleIconSuccess(res, file){
      this.form.Icon= res.fullUrl
    },
  },
  created(){
  
  },
}
</script>